var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',[_c('v-img',{attrs:{"src":_vm.image_src,"contain":true,"height":"80px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }